import { render } from "./AppSection.vue?vue&type=template&id=8a5b1c8e"
import script from "./AppSection.vue?vue&type=script&lang=js"
export * from "./AppSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__